export default __webpack_public_path__ + "static/media/header-ico-arrow.6c191097.svg";